var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1993",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.08594 5.87378H28.5815C29.801 5.87378 30.7895 6.86255 30.7895 8.08173V23.4815H8.08594V5.87378Z",
    fill: "#E25252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3471 12.1042H22.7512C21.0211 12.1042 19.6057 13.5197 19.6057 15.2497C19.6057 16.9797 21.0211 18.3951 22.7512 18.3951H30.7895V9.26123C30.7895 11.8033 28.1799 12.0804 27.3471 12.1042Z",
    fill: "#F46262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89008 40.0001C9.85413 40.0001 10.643 39.2112 10.643 38.2474V4.06836C10.643 3.10431 9.85413 2.31543 8.89008 2.31543C7.92603 2.31543 7.13745 3.10431 7.13745 4.06836V38.2474C7.13745 39.2112 7.92603 40.0001 8.89008 40.0001Z",
    fill: "#D8D7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89008 2.31543C7.92603 2.31543 7.13745 3.104 7.13745 4.06805V8.50928C8.61237 8.30664 9.7583 7.83575 10.643 7.2608V4.06836C10.643 3.10431 9.85413 2.31543 8.89008 2.31543Z",
    fill: "#C6C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4496 23.0656L34.5065 18.3057C35.3549 16.9846 34.4064 15.2479 32.8363 15.2479H25.2579C21.2036 15.1774 22.7512 12.1042 22.7512 12.1042C21.0217 12.1042 19.6066 13.5203 19.6057 15.2497V26.8094C19.6057 29.0595 21.4297 30.8835 23.6798 30.8835H32.8363C34.4064 30.8835 35.3549 29.1468 34.5065 27.8257L31.4496 23.0656Z",
    fill: "#FF737D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4471 2.55676C11.4471 3.96912 10.3024 5.11383 8.89008 5.11383C7.47803 5.11383 6.33331 3.96912 6.33331 2.55676C6.33331 1.14471 7.47803 0 8.89008 0C10.3024 0 11.4471 1.14471 11.4471 2.55676Z",
    fill: "#EAEAEA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.6e449ca94727c5957c253498b73f4a30.svg";
export { ForwardRef as ReactComponent };